import React, { useEffect, useState, useContext, useMemo } from "react";

import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory, Link } from "react-router-dom";
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import CarPasantiaAplicaciones from "../element/CarPasantiaAplicaciones";
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
// import socket from '../componentes/Socket';
import Menu from "../componentes/Menu";
import dataSuper from "../hooks/Conf";
import dataDE from "../hooks/useDireccionEstudiantil";

// Contexto
import dataContext from "../context/User";
// Helper
import GetFetch from "../helper/GetFetch";
import loadMenu from "../js/main";

const PasantiasAllOFF = () => {
  const history = useHistory();
  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem("dataUser");

  const [pasantias, setPasantias] = useState();
  const [cargando, setCargando] = useState(true);
  // Filtros
  const [busqueda, setBusqueda] = useState("");
  const [areaFiltro, setAreaFiltro] = useState("");
  const [empresaFiltro, setEmpresaFiltro] = useState("");
  const [aplicantesFiltro, setAplicantesFiltro] = useState("");

  if (datos) {
    let cred = JSON.parse(datos);
    dataUser.token = cred.token;
    dataUser.nombre = cred.nombre;
    dataUser.carnet = cred.carnet;
    dataUser.email = cred.correo;

    if (dataSuper.indexOf(cred.carnet.trim()) === -1) {
      if (dataDE.indexOf(cred.carnet.trim()) === -1) {
        history.push("/");
      }
    }
  } else {
    history.push("/");
  }

  useEffect(() => {
    let dataPasantias = () => {
      GetFetch.getPasantiaAllOFF(dataUser.token).then((pasantiaData) => {
        setPasantias(pasantiaData);
        setCargando(false);
      }).catch(() => setCargando(false));
    };
    dataPasantias();
    loadMenu();
  }, [dataUser]);

  // const pasantiaBody = (descripcion) => {
  //   return { __html: descripcion };
  // };

  const normalizar = (texto) =>
    (texto || "")
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(new RegExp("[\\u0300-\\u036f]", "g"), "")
      .trim();

  const areas = useMemo(() => {
    if (!Array.isArray(pasantias)) return [];
    return [...new Set(pasantias.map((p) => (p.area || "").trim()).filter(Boolean))].sort();
  }, [pasantias]);

  const empresas = useMemo(() => {
    if (!Array.isArray(pasantias)) return [];
    return [...new Set(pasantias.map((p) => (p.empresa || "").trim()).filter(Boolean))].sort();
  }, [pasantias]);

  const pasantiasFiltradas = useMemo(() => {
    if (!Array.isArray(pasantias)) return [];
    const texto = normalizar(busqueda);
    return pasantias.filter((p) => {
      if (texto) {
        const contenido = normalizar(`${p.titulo} ${p.empresa} ${p.area}`);
        if (contenido.indexOf(texto) === -1) return false;
      }
      if (areaFiltro && (p.area || "").trim() !== areaFiltro) return false;
      if (empresaFiltro && (p.empresa || "").trim() !== empresaFiltro) return false;
      const totalAplicantes = p.aplicaciones ? p.aplicaciones.length : 0;
      if (aplicantesFiltro === "con" && totalAplicantes === 0) return false;
      if (aplicantesFiltro === "sin" && totalAplicantes > 0) return false;
      return true;
    });
  }, [pasantias, busqueda, areaFiltro, empresaFiltro, aplicantesFiltro]);

  const hayFiltros = busqueda !== "" || areaFiltro !== "" || empresaFiltro !== "" || aplicantesFiltro !== "";

  const limpiarFiltros = () => {
    setBusqueda("");
    setAreaFiltro("");
    setEmpresaFiltro("");
    setAplicantesFiltro("");
  };

  return (
    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            posicion="text-center"
          />

          <Menu />

          <div className="footer">
            <p>
              Copyright &copy;
              {/* <script>
                                document.write(new Date().getFullYear());
                            </script> All rights reserved | This template is made with <i className="icon-heart" aria-hidden="true"></i> by <a href="https://colorlib.com" target="_blank">Colorlib.com</a> */}
            </p>
          </div>
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Pasantías deshabilitadas</h2>
        {!cargando && pasantias && pasantias.length > 0 && (
          <div className="card mb-4">
            <div className="card-body">
              <div className="form-row">
                <div className="form-group col-md-4">
                  <label htmlFor="filtro-busqueda">Buscar</label>
                  <input
                    type="text"
                    className="form-control"
                    id="filtro-busqueda"
                    placeholder="Título, empresa o área"
                    value={busqueda}
                    onChange={(e) => setBusqueda(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-3">
                  <label htmlFor="filtro-empresa">Empresa</label>
                  <select
                    className="form-control"
                    id="filtro-empresa"
                    value={empresaFiltro}
                    onChange={(e) => setEmpresaFiltro(e.target.value)}
                  >
                    <option value="">Todas</option>
                    {empresas.map((empresa) => (
                      <option key={empresa} value={empresa}>{empresa}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-3">
                  <label htmlFor="filtro-area">Área</label>
                  <select
                    className="form-control"
                    id="filtro-area"
                    value={areaFiltro}
                    onChange={(e) => setAreaFiltro(e.target.value)}
                  >
                    <option value="">Todas</option>
                    {areas.map((area) => (
                      <option key={area} value={area}>{area}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-2">
                  <label htmlFor="filtro-aplicantes">Aplicantes</label>
                  <select
                    className="form-control"
                    id="filtro-aplicantes"
                    value={aplicantesFiltro}
                    onChange={(e) => setAplicantesFiltro(e.target.value)}
                  >
                    <option value="">Todas</option>
                    <option value="con">Con aplicantes</option>
                    <option value="sin">Sin aplicantes</option>
                  </select>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <small className="text-muted">
                  Mostrando <b>{pasantiasFiltradas.length}</b> de <b>{pasantias.length}</b> pasantías
                </small>
                {hayFiltros && (
                  <button type="button" className="btn btn-outline-secondary btn-sm" onClick={limpiarFiltros}>
                    <i className="fa fa-times mr-1" aria-hidden="true"></i>Limpiar filtros
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
        {cargando ? (
          <SkeletonCard rows={4} />
        ) : pasantiasFiltradas.length > 0 ? (
          pasantiasFiltradas.map((data, i) => {
            return (
              <div key={data._id || i} className="card mb-3">
                <div className="card-body">
                  {/* <p className="card-text" dangerouslySetInnerHTML={pasantiaBody(data.descripcion)}></p> */}
                  <div className="d-flex align-items-start justify-content-between mb-2">
                    <h3 className="h5 mb-0">{i + 1}. {data.titulo}</h3>
                    <span className="esen-chip esen-chip--neutral ml-2">Deshabilitada</span>
                  </div>
                  <p className="mb-1">Empresa: <b>{data.empresa}</b></p>
                  <p className="mb-3">Área: {data.area}</p>
                  <Link to={'pasantias?id_pasantia='+ data._id} className="btn btn-outline-primary btn-sm mr-2">
                    <i className="fa fa-pencil mr-1" aria-hidden="true"></i>Editar
                  </Link>
                  <Link to={'adminpasantiasapply?id_pasantia='+ data._id} className="btn btn-outline-primary btn-sm">
                    <i className="fa fa-users mr-1" aria-hidden="true"></i>Aplicantes: <b>{data.aplicaciones.length}</b>
                  </Link>
                  <CarPasantiaAplicaciones
                  datos = {data.aplicaciones}
                  _id = {data._id}
                   />
                </div>
              </div>
            );
          })
        ) : pasantias && pasantias.length > 0 && hayFiltros ? (
          <EmptyState icon="fa-filter" title="Sin resultados para los filtros aplicados">
            Ajusta la búsqueda o limpia los filtros para ver todas las pasantías.
          </EmptyState>
        ) : (
          <EmptyState icon="fa-briefcase" title="Aún no hay pasantías deshabilitadas">
            Las pasantías que lleguen a su fecha de cierre aparecerán aquí.
          </EmptyState>
        )}
      </div>
    </div>
  );
};

export default PasantiasAllOFF;
